import { useState } from "react";
import { usePreparationSettingsCatalog } from "./usePreparationSettingsCatalog";
import { usePreparationRouteWorkspace } from "./usePreparationRouteWorkspace";
import { useWarehouseResponsibilitiesWorkspace } from "./useWarehouseResponsibilitiesWorkspace";
export function usePreparationSettingsWorkspace({ notify, dataRefreshVersion }: {
    notify: (message: string) => void;
    dataRefreshVersion: number;
}) {
    const [selectedUserId, setSelectedUserId] = useState("");
    const [lineId, setLineId] = useState("");
    const [productCode, setProductCode] = useState("");
    const [error, setError] = useState<string | null>(null);
    const catalog = usePreparationSettingsCatalog({ dataRefreshVersion, setError, setSelectedUserId, setLineId, setProductCode });
    const route = usePreparationRouteWorkspace({ reference: catalog.reference, lineId, productCode, setError, notify });
    const assignment = useWarehouseResponsibilitiesWorkspace({ warehouseUsers: catalog.warehouseUsers, selectedUserId, notify });
    return { ...catalog, ...route, ...assignment, lineId, setLineId, productCode, setProductCode, selectedUserId, setSelectedUserId, error };
}
